import { Type } from 'class-transformer';
import { ValidateNested } from 'class-validator';
import createCollectionResource from 'src/actions/shared/createResource';

export class Twitter {
  id: string;
  accountId: string;
  address: string;

  type: string = 'TWITTER';

  @ValidateNested()
  @Type(() => TwitterConfiguration)
  configuration: TwitterConfiguration;

  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export class TwitterConfiguration {
  appId: string;
  displayName: string;
  enabled: boolean;
  handle: string;
  provider: string;
}

const twitterResource = createCollectionResource<Twitter>({
  name: 'twitter',
  endpoint: 'v1/orgs/:orgId/configuration/endpoints/:id',
  type: Twitter,
});

export default twitterResource;
